import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const useAuthRedirect = () => {
    const navigate = useNavigate();

    const handleAuthError = useCallback((status) => {
        if (status === 401) {
            localStorage.removeItem('token');
            navigate('/login');
            return true; // Indicates that a redirect occurred
        }
        return false; // No redirect
    }, [navigate]);

    return handleAuthError;
};
